import styled from 'styled-components';
import { Tab, TabGroup } from 'ui/tabs';
import { backgroundColors, colors, spacing } from 'ui/theme';
import { normalPageMaxWidth } from 'ui/theme/spacing';
import { pxToRem } from 'utils/convert';
import { PageContainer } from '../CommonStyled';

const customSpacing = {
  p3: pxToRem(3),
  p20: pxToRem(20),
  p40: pxToRem(40),
};

export const FullWidthPageContainer = styled(PageContainer)`
  margin: -${customSpacing.p20} -${customSpacing.p40} -${customSpacing.p20};
`;

export const PageHeaderBackground = styled.div`
  background: ${backgroundColors.backgroundPrimary};
`;

export const PageBodyBackground = styled.div`
  background: ${backgroundColors.backgroundSecondary};
`;

export const ContentWrapper = styled.div`
  max-width: ${normalPageMaxWidth};
  margin: 0 auto;
`;

export const StyledTabGroup = styled(TabGroup)`
  width: 100%;
  border-top: ${spacing.single} solid ${colors.grey15};
  border-bottom: ${spacing.single} solid ${colors.grey15};
`;

export const StyledTab = styled(Tab)`
  padding-top: ${customSpacing.p20};
  padding-bottom: ${customSpacing.p20};
  border-bottom: ${({ isSelected }) =>
    isSelected ? `${customSpacing.p3} solid ${colors.purple100}` : 'none'};
  color: ${({ isSelected }) => (isSelected ? colors.purple100 : colors.textSecondary)};
`;

export const TabPanel = styled.div`
  padding-bottom: ${spacing.double};
`;
